import { render, staticRenderFns } from "./Tr.vue?vue&type=template&id=6cd96e68&scoped=true&"
import script from "./Tr.vue?vue&type=script&lang=js&"
export * from "./Tr.vue?vue&type=script&lang=js&"
import style0 from "./Tr.vue?vue&type=style&index=0&id=6cd96e68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd96e68",
  null
  
)

export default component.exports